export {
  InvalidEmailReason,
  isPersonalDomain,
  isValidEmail,
  getDomainOffEmail,
  isEmailInDomains,
  isValidEmailFormat,
} from "@clockwise/client-commons/src/util/email";
